import Vue from 'vue'
import { provider } from '@/services'
import { IStore } from '@/store/modules/application'
import { AppSettings, IAppSettings } from '@/entities'
import axios from 'axios';

// rename to GMS store..
export async function prepareServices (store: IStore) {
  store.$services = provider()
  let appSettings: AppSettings;

  appSettings = await loadSettings();
 
  Vue.mixin({
    data() {
      return {
        "appSettings": appSettings
      }
    },
    beforeCreate () {
      this.$services = store.$services
    }
  });  
}

/** load application settings */
async function loadSettings() {
  return await axios.get(process.env.VUE_APP_API_Base_URL + 'api/Dashboard/AppSettings').then((resp) => {
    if (resp.status >= 200 && resp.status < 300) {
      return new AppSettings(resp.data);
    } else {
      return new AppSettings({} as IAppSettings);
    }
  }).catch((ex) => {
    return new AppSettings({} as IAppSettings);
  });
}